<template>
    <div class="tc-sidebar-right-items-body-card">
        <img class="tc-sidebar-right-items-body-card-image"
             :src="getImage(item.image)">
        <div class="tc-sidebar-right-items-body-card-description">
            <div class="tc-sidebar-right-items-body-card-description-text"
                 :title="item.name">
                {{item.name}}
            </div>
            <ItemCounter :number="counterValue"
                         :min-value="0"
                         :max-value="maxCount"
                         @change="(value) => storeCaseConfiguration.setDrawerSeparatorCountById(item.id, +value, drawerPrototypeId)"
                         @decrease="storeCaseConfiguration.setDrawerSeparatorCountById(item.id, +counterValue - 1, drawerPrototypeId)"
                         @increase="storeCaseConfiguration.setDrawerSeparatorCountById(item.id, +counterValue + 1, drawerPrototypeId)"/>
        </div>
    </div>
</template>

<script>
import ItemCounter from '@/UI/CommonComponents/ItemCounter.vue';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { getImage } from '@/libs/getImage';

export default {
    name: 'ResultItemCardChild',
    components: {
        ItemCounter,
    },
    setup() {
        const storeCaseConfiguration = useStoreCaseConfiguration();
        return {
            storeCaseConfiguration,
        };
    },
    props: [
        'item',
        'drawerPrototypeId',
        'maxCount',
    ],
    computed: {
        counterValue() {
            return this.storeCaseConfiguration.getCountOfDrawerSeparatorById(this.item.id);
        },
    },
    methods: {
        getImage,
    },
};
</script>

<style scoped lang="scss">
@import "CSS/rigtSIdebarItems";
</style>
